import './Loading.scss';

function Loading(props) {
	return (<div className={"loading"}>
		<img alt={'Loading...'} src={'/loading.gif'} />
	</div>)
}

export default Loading;